import React, { FC, useCallback, useEffect } from "react";
import { useMap } from "../../../App";
import ol from "openlayers";
import { InventoryGeometryItem } from "../../../hooks/database/types/inventories";
import { useBaseGeometryController } from "./useBaseGeometryController";
import { useMapProjection } from "../../../hooks/useMapView";
import mapUtils from "../../../utils/map";

const ModifyPoint: FC<{
  coordinate: ol.Coordinate;
  onCancel: () => void;
  onSave: (geojson: InventoryGeometryItem["geom"]) => void;
}> = (props) => {
  const { saveGeometry } = useBaseGeometryController(props.onSave);

  const map = useMap()!;
  const handleConfirmClick = useCallback(() => {
    const center = map.getView().getCenter();
    saveGeometry(new ol.geom.Point(center));
  }, [map, saveGeometry]);

  const projection = useMapProjection();
  useEffect(() => {
    mapUtils.panToCoord(map, ol.proj.transform(props.coordinate, "EPSG:4326", projection));
  }, [map, projection, props.coordinate]);

  return (
    <>
      <i className="fa fa-crosshairs draw-crosshair" />

      <button className="draw-confirm button button-fill" onClick={handleConfirmClick}>
        CONFIRM POSITION
      </button>

      <button className="draw-cancel button button-fill" onClick={props.onCancel}>
        CANCEL
      </button>
    </>
  );
};

export default ModifyPoint;
